/**
 * Certification Service
 *
 * Provides functionality for working with certification data.
 */

import { apiClient } from '../../core/api/client';
import { ApiService } from '../../core/api/service';
import {
    ApiResponse,
    CertificationCreateCertificationsRequest,
    CertificationCreateCertificationsResponseItem,
    CertificationDeleteCertificationsRequest,
    CertificationDeleteCertificationsResponseItem,
    CertificationGetCertificationRequest,
    CertificationGetCertificationResponseItem,
    CertificationSearchRequest,
    CertificationSearchResponseItem,
    CertificationUpdateCertificationsRequest,
    CertificationUpdateCertificationsResponseItem
} from "../../../model";

export class CertificationService extends ApiService {
    /**
     * Search certifications based on criteria
     */
    async search(request: CertificationSearchRequest): Promise<CertificationSearchResponseItem[] | null> {
        try {
            const response = await apiClient.post<ApiResponse<CertificationSearchResponseItem[]>>(
                '/api/certification/search',
                request
            );

            return this.processResponse(response);
        } catch (error) {
            return this.handleError(error);
        }
    }

    /**
     * Get certification details by ID or code
     */
    async getCertification(
        request: CertificationGetCertificationRequest
    ): Promise<CertificationGetCertificationResponseItem | null> {
        try {
            const response = await apiClient.post<ApiResponse<CertificationGetCertificationResponseItem>>(
                '/api/certification/getCertification',
                request
            );

            return this.processResponse(response);
        } catch (error) {
            return this.handleError(error);
        }
    }
    
    /**
     * Create new certifications
     */
    async createCertifications(
        request: CertificationCreateCertificationsRequest
    ): Promise<CertificationCreateCertificationsResponseItem | null> {
        try {
            const response = await apiClient.post<ApiResponse<CertificationCreateCertificationsResponseItem>>(
                '/api/certification/create',
                request
            );

            return this.processResponse(response);
        } catch (error) {
            return this.handleError(error);
        }
    }

    /**
     * Update existing certifications
     */
    async updateCertifications(
        request: CertificationUpdateCertificationsRequest
    ): Promise<CertificationUpdateCertificationsResponseItem | null> {
        try {
            const response = await apiClient.post<ApiResponse<CertificationUpdateCertificationsResponseItem>>(
                '/api/certification/update',
                request
            );

            return this.processResponse(response);
        } catch (error) {
            return this.handleError(error);
        }
    }

    /**
     * Delete certifications
     */
    async deleteCertifications(
        request: CertificationDeleteCertificationsRequest
    ): Promise<CertificationDeleteCertificationsResponseItem | null> {
        try {
            const response = await apiClient.post<ApiResponse<CertificationDeleteCertificationsResponseItem>>(
                '/api/certification/delete',
                request
            );

            return this.processResponse(response);
        } catch (error) {
            return this.handleError(error);
        }
    }
}

// Export a singleton instance
export const certificationService = new CertificationService();
